// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import Gravatar from 'vue-gravatar'
import Vue2Filters from 'vue2-filters'
import VTree from 'vue-tree-halower'
import VueMatchHeights from 'vue-match-heights'
import 'vue-tree-halower/dist/halower-tree.min.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import VueContentPlaceholders from 'vue-content-placeholders'
import Transitions from 'vue2-transitions'
import vuexI18n from 'vuex-i18n'
import English from './lang/en.js'
import French from './lang/fr.js'
import Spanish from './lang/es.js'
import App from './App'
import router from './router'
import store from './store/store'
import './plugins/progressBarConfig'
import './plugins/toastedConfig'
import Ripple from 'vue-ripple-directive'
import './components/mixins/filters'
import 'vue-search-select/dist/VueSearchSelect.css'
import 'vue2-timepicker/dist/VueTimepicker.css'
import CryptoJS from 'crypto-js'
import './services/api'
import axios from 'axios'
import VueAxios from 'vue-axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'

let refresherAxiosInstance = axios.create()

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(Vue2Filters)
Vue.use(VTree)
Vue.use(VueMatchHeights, {})
Vue.use(VueContentPlaceholders)
Vue.use(Transitions)
Vue.use(vuexI18n.plugin, store)
Vue.directive('ripple', Ripple)
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.API_URL
const refreshAuthLogic = async failedRequest => {
  if (failedRequest.request.responseURL.includes('/logout')) {
    return Promise.reject(new Error('Error'))
  }
  let refreshToken = store.getters.refreshToken
  let data = new window.FormData()
  data.append('auth[refresh_token]', refreshToken)
  let headers = { headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0'
  }}
  await refresherAxiosInstance.post('/refresh', data, headers)
    .then(res => {
      let { enc_data: { iv = null, data = null } = {} } = res.data || {}
      if (iv && data) {
        let key = CryptoJS.enc.Base64.parse(process.env.RESPONSE_SIGNER.replace(/\n/g, ''))
        iv = CryptoJS.enc.Base64.parse(iv.replace(/\n/g, ''))
        data = data.replace(/\n/g, '')
        const decrypted = CryptoJS.AES.decrypt((data), (key), { iv: iv })
        try {
          let jsonPayload = CryptoJS.enc.Utf8.stringify(decrypted)
          res.data = JSON.parse(jsonPayload)
        } catch (error) {
          console.error(error)
        }
      }
      let token = res.data.token.token
      if (token) {
        store.dispatch('updateToken', {token: token})
        failedRequest.response.config.baseURL = ''
        failedRequest.response.config.headers['Authorization'] = 'Bearer ' + token
        return Promise.resolve()
      } else {
        return Promise.reject(new Error('Error'))
      }
    })
}
createAuthRefreshInterceptor(Vue.axios, refreshAuthLogic)
Vue.axios.interceptors.request
  .use(config => {
    // console.log(config)
    if (config.url.startsWith('/api')) {
      config.url = config.url.replace(/^\/api(\/api)?/, '')
      config.baseURL = process.env.API_URL
    }
    if (config.url.includes('/admin') || config.url.includes('/users')) {
      config.headers['Cache-Control'] = 'no-cache, no-store'
      config.headers['Pragma'] = 'no-cache'
      config.headers['Expires'] = '0'
    }
    let token = store.getters.idToken
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    vueApp.$Progress.start()
    return config
  }, error => {
    vueApp.$Progress.fail()
    return error
  })
Vue.axios.interceptors.response
  .use(config => {
    let { enc_data: { iv = null, data = null } = {} } = config.data || {}
    if (iv && data) {
      let key = CryptoJS.enc.Base64.parse(process.env.RESPONSE_SIGNER.replace(/\n/g, ''))
      iv = CryptoJS.enc.Base64.parse(iv.replace(/\n/g, ''))
      data = data.replace(/\n/g, '')
      const decrypted = CryptoJS.AES.decrypt((data), (key), { iv: iv })
      try {
        let jsonPayload = CryptoJS.enc.Utf8.stringify(decrypted)
        config.data = JSON.parse(jsonPayload)
      } catch (error) {
        console.error(error)
      }
    }
    vueApp.$Progress.finish()
    return config
  }, error => {
    const apiPattern = /^\/api\/api/
    let url = error.response.config.url
    if (apiPattern.test(url)) {
      error.response.config.url = error.response.config.url.replace(apiPattern, '/api')
      error.response.config.baseURL = ''
    }
    vueApp.$Progress.fail()
    if (error.response && error.response.status === 401 && router.currentRoute.path !== '/sign_in') {
      Vue.toasted.clear()
      Vue.toasted.show('Session expired, please login to continue', { icon: 'chain-broken', type: 'error', singleton: true })
      store.dispatch('logOut')
      console.log('sing in route')
      router.replace(`/sign_in?redirect_to=${encodeURIComponent(router.currentRoute.fullPath)}`)
    }
    return Promise.reject(error.response)
  })

Vue.i18n.add('en', English)
Vue.i18n.add('fr', French)
Vue.i18n.add('es', Spanish)
Vue.i18n.set('en')
Vue.i18n.fallback('en')

// TODO: This is a temporary implementation
Vue.component('v-gravatar', Gravatar)
window.addEventListener('storage', (event) => {
  if (event.key === 'logout-event') {
    store.commit('logOut')
    router.replace('/log_in')
  }
})
/* Application initialize */
const vueApp = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})

// Initilize Axios and setup Interceptors
export default { vueApp }



// WEBPACK FOOTER //
// ./src/main.js